import React from "react";
import s from './zero-height-loading-animation2.module.scss';
import LoadingAnimation2 from "./LoadingAnimation2";

/**
 * The default LoadingAnimation2 component fills some space and absolutely positioning it introduces other problems.
 * This component allows the loading animation to exist, without taking up real-estate on the page.
 */
export default function ZeroHeightLoadingAnimation2() {
  return (
    <div className={s.container}>
      {/* Wrapper div prevents the loading animation from taking up space, so the content is not pushed down. */}
      <LoadingAnimation2/>
    </div>
  );
}
